import React, { useEffect } from 'react';
import {
	Case,
	CaseType,
	useMonitoringCentreCasesQuery,
} from '../../../../graphql/graphql';
import MonitoringCenterList from '../MonitoringCenterList/MonitoringCenterList';
import styles from './MonitoringCenterNewRequestsItem.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';
import { MonitoringCenterDefaultColumns } from '../../Consts/MonitoringCenterDefaultColumns.const';
import { useFlatDataList } from '../../../Base/Hooks/useFlatDataList';

interface Props {
	filter?: object;
	caseType: CaseType;
	onBack: () => void;
}

const MonitoringCenterNewRequestsItemDetail: React.FC<Props> = ({
	filter,
	caseType,
	onBack,
}) => {
	const { flatData, pagination, getNextPage, appendData } =
		useFlatDataList<Case>(filter);

	const { data, isLoading, refetch } = useMonitoringCentreCasesQuery({
		...filter,
		caseTypeCode: caseType.code,
		pagination,
	});

	useEffect(() => {
		appendData((data?.monitoringCentreCases?.data as Case[]) ?? []);
	}, [data]);

	useEffect(() => {
		refetch();
	}, [filter]);

	useSocket(Socket.CASE_TAKEN, refetch);

	return (
		<div className={styles.wrapper}>
			<div className={styles.titleWrapper}>
				<div className={styles.title}>
					<div>{caseType.label}</div>
					<div className={styles.count}>
						{data?.monitoringCentreCases?.meta?.count}
					</div>
				</div>
				<div>
					<LinkButton
						title='base.shared.back'
						theme={Theme.BLUE}
						onClick={onBack}
						firstUpper
					/>
				</div>
			</div>
			<MonitoringCenterList
				data={flatData}
				onLoadMore={getNextPage}
				onRefresh={refetch}
				isLoading={isLoading}
				hasMoreData={data?.monitoringCentreCases?.meta?.hasNextPage || false}
				columns={MonitoringCenterDefaultColumns}
			/>
		</div>
	);
};

export default MonitoringCenterNewRequestsItemDetail;
